import { MQ_SMALL_ONLY, MQ_LARGE, MQ_MIDLARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base3x2, medium3x2 } = IMAGE_SIZES;

const base = {
  fallbackDims: base3x2,
  sourceSets: [
    {
      layoutWidth: { value: 294, units: 'px' },
      imageDims: medium3x2,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 365, units: 'px' },
      imageDims: medium3x2,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 334, units: 'px' },
      imageDims: medium3x2,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 100, units: 'vw' },
      imageDims: medium3x2,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: '(min-width: 0)',
      ratio: 3 / 2
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
